export default {"src":"/_next/static/image/public/assets/icons/quote.6abf7300da47820c7023952cb6777552.svg","height":24,"width":24};